/*
 * @Author: JamesWong
 * @Description: 仓库模块中文包
 * @Date: 2018-11-29 18:56:25
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-17 11:22:59
 */
export default {
  authorizedWarehouse: '已授权仓库',
  deleteWarehouse: '删除仓库',
  hint: '提示',
  deleteWarehouseTips: '删除后该仓库将不能使用POS登录，确定删除该仓库吗?',
  cancel: '取消',
  confirmDelete: '确定删除',
  addWarehouse: '新增仓库',
  addAuthorizedWarehouse: '新增授权仓库',
  searchAuthorizedWarehouse: '搜索已授权仓库',
  Order: '序号',
  warehouseNumber: '仓库编号',
  warehouseAbbreviation: '仓库简称',
  warehouseFullname: '仓库全称',
  confirm: '确定',
  searchWarehouse: '搜索仓库',
  authorizedWarehouseAdded: '授权仓库新增成功！',
  authorizedWarehouseDeleted: '授权仓库删除成功！'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/warehouse.js